import OptionGenerator from '../Generic/Options';

export default OptionGenerator(
    'charts',
    ({clientId}, obj) => {
        return obj.clientId === clientId;
    }
);


// WEBPACK FOOTER //
// ./src/container/Chart/ChartOptions.tsx